import clsx from 'clsx';
import React, {
  ReactNode,
} from 'react';
import Label from 'pages/Dashboard/components/Label';

export type Prop = {
  id: string;
  containerClassName?: string;
  className?: string;
  label?: string;
  actions?: ReactNode;
  required?: boolean;
};

function LabelWithActions({
  id,
  containerClassName,
  className,
  actions,
  label,
  required,
}: Prop) {
  const containerClasses = clsx('flex items-center justify-between', containerClassName);

  return (
    <div className={containerClasses}>
      <Label
        id={id}
        label={label}
        required={required}
        className={clsx('pr-1.5', className)}
      />
      {actions}
    </div>
  );
}

export default LabelWithActions;
